import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1319InputVO } from "../vo/kymw1319-inputVO.model";

export type GetBundleCatalogInfoForFeatureResponce = {
  StartOrderCode: string,
  EndOrderCode: string,
  BundleCatalogRoundName: string,
  ProgressWorkNum: string,
}

/**
 * 特集用束ね企画情報取得
 * 
 * @export GetBundleCatalogInfoForFeatureService
 * @class GetBundleCatalogInfoForFeatureService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetBundleCatalogInfoForFeatureService extends PlessJsonResponderSub<GetBundleCatalogInfoForFeatureResponce> {
  vo: KYMW1319InputVO;
  successFunc: Function;

  /**
   * bodyにセットする値を返す
   * 
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetBundleCatalogInfoForFeatureService
   */
  getBody() {
    return new PlessRequest({
      search: {
        BundleFeatureInfo: {
          condition: {
            OrderCode: this.vo.orderCode !== '' ? this.vo.orderCode : this.vo.startOrderCode,
            MediumType: this.vo.mediumType,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param vo 
   * @param successFunc
   * @memberof GetBundleCatalogInfoForFeatureService 
   */
  execute(vo: KYMW1319InputVO, successFunc: Function = null) {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getBundleCatalogInfoForFeature', this.getBody())
  }

  /**
   * API通信成功時の処理
   * 
   * @param data 
   * @memberof GetBundleCatalogInfoForFeatureService
   */
  success(data: GetBundleCatalogInfoForFeatureResponce): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}